<div class="container-scroller">
  <div>
    <img class="bg" src="assets/images/bg01.jpg" style="height: 100vh; width: 100vw;">
    <div class="container-fluid" style="height: 100vh;">

      <div class="row banner-content" style="height: 100vh; margin-left: 0px; margin-right: auto;">
        <div class="col-lg-6 col-sm-12 text-right" style="margin-top: auto; margin-bottom: auto;
                display: flex;
          -ms-flex-wrap: wrap;
          flex-wrap: wrap;">
          <!-- <img class="col-lg-5 col-sm-5 mr-2" src="assets/images/logo.png" style="margin: 0px;padding: 0px;">
          <img class="col-lg-5 col-sm-5 ml-2" src="assets/images/logoss.png" style="margin: 0px;padding: 0px;"> -->
          <img class="col-lg-12 col-sm-12" src="assets/images/logover2.png" style="margin: 0px;padding: 0px;">
        </div>
        <div class="col-lg-6 col-sm-12 text-center" style="margin-top: auto; margin-bottom: auto;">
          <h3 class="text-black font-weight-light "> ระบบฐานข้อมูลกองทุนจัดรูปที่ดินเพื่อพัฒนาพื้นที่ </h3>
          <h1 class="text-black"> Land Readjustment Fund Database</h1>
          <button class="btn btn-gradient-danger text-center col-lg-4 col-md-4 col-sm-8" data-toggle="modal" data-target="#login"
            style="cursor: pointer; font-size: medium;">เข้าสู่ระบบ</button>
        </div>

        <div class="modal fade" id="login" tabindex="-1" role="dialog" aria-labelledby="เข้าสู่ระบบ"
          aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div class="auth-form-light p-5">
                  <h3 style="width: 100%; text-align: center;">ยินดีต้อนรับเข้าสู่ระบบ</h3><br>
                  <h6 class="font-weight-light"></h6>
                  <form [formGroup]="login_form">
                    <div class="form-group">
                      <input type="email" class="form-control form-control-lg" formControlName="user"
                        placeholder="ชื่อผู้ใช้" required>
                    </div>
                    <div class="form-group">
                      <input type="password" class="form-control form-control-lg" formControlName="password"
                        placeholder="รหัสผ่าน" required>
                    </div>
                    <button class="btn btn-gradient-primary btn-block btn-fw btn-lg font-weight-medium auth-form-btn"
                      id="login_btn" data-toggle="modal" [disabled]="!login_form.valid" data-target="#select_mode"
                      (click)="onClickLogin()" data-dismiss="modal">เข้าสู่ระบบ</button>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="select_mode" tabindex="-1" role="dialog" aria-labelledby="เลือกโหมดการทำงาน"
          aria-hidden="true">
          <button type="button" class="close" data-dismiss="modal" aria-label="ปิด" (click)="closeModal()"
            #closeAddExpenseModal>
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-dialog" role="document" *ngIf="admin_id" [ngClass]="{'modal-lg': mode == 'superadmin'}">
            <div class="modal-content">
              <div class="modal-header" style="background-color: white;">
                <h5 class="modal-title" id="exampleModalLabel-2">
                  กองทุนจัดรูปที่ดินเพื่อพัฒนาพื้นที่
                </h5>
                <!-- โครงการที่ได้รับเงินสนับสนุนจากกองทุนฯ -->
                <button type="button" class="close" data-dismiss="modal" aria-label="ปิด" (click)="closeModal()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body" style="background-color: white;max-height: 60vh;" id="modal-add" [ngClass]="{'sc-y': mode == 'superadmin'}">
                <div class="" [ngClass]="{'table-responsive': mode == 'superadmin'}" >
                  <div class="row">
                    <div class="col-md-4 grid-margin stretch-card" *ngIf="mode == 'general' || mode == 'superadmin'"
                      style="margin-left: auto; margin-right: auto;"
                      [ngClass]="{'col-md-4': mode == 'superadmin', 'col-md-9': mode != 'superadmin'}">
                      <div class="m-3 grid-margin stretch-card"><button (click)="onClickManage()"
                          class="btn btn-rounded border-btn btn-outline-danger" data-dismiss="modal" id="general">
                          <img alt="image" class="card-img-top" src="assets/images/manage.png">
                          <h3 class="font-weight-normal mb-0 text-center">
                            ฝ่ายบริหารงานทั่วไป</h3>
                        </button></div>
                    </div>
                    <div class="grid-margin stretch-card text-center"
                      *ngIf="mode == 'finance' || mode == 'superadmin'" style="margin-left: auto; margin-right: auto;"
                      [ngClass]="{'col-md-4': mode == 'superadmin', 'col-md-9': mode != 'superadmin'}">
                      <div class="m-3 grid-margin stretch-card btn-rounded"><button id="finance"
                          class="btn btn-rounded border-btn btn-outline-danger" data-dismiss="modal"
                          [routerLink]="[ '/dashboard']">
                          <img alt="image" class="card-img-top" src="assets/images/finance.png">
                          <h3 class="font-weight-normal mb-0 text-center">
                            ฝ่ายการเงินและบัญชี </h3>
                        </button></div>
                    </div>
                    <div class="col-md-4 grid-margin stretch-card" *ngIf="mode == 'invest' || mode == 'superadmin'"
                      style="margin-left: auto; margin-right: auto;"
                      [ngClass]="{'col-md-4': mode == 'superadmin', 'col-md-9': mode != 'superadmin'}">
                      <div class="m-3 grid-margin stretch-card"><button id="invest" (click)="onClickAnalyze()"
                          class="btn btn-rounded border-btn btn-outline-danger" data-dismiss="modal">
                          <img alt="image" class="card-img-top" src="assets/images/analyze.png">
                          <h3 class="font-weight-normal mb-0 text-center">
                            ฝ่ายวิเคราะห์ติดตาม และการลงทุน</h3>
                        </button></div>
                    </div>
                    <div class="grid-margin stretch-card text-center"
                      *ngIf="mode == 'committee' || mode == 'superadmin'" style="margin-left: auto; margin-right: auto;"
                      [ngClass]="{'col-md-4': mode == 'superadmin', 'col-md-9': mode != 'superadmin'}">
                      <div class="m-3 grid-margin stretch-card btn-rounded"><button id="committee"
                          class="btn btn-rounded border-btn btn-outline-danger" data-dismiss="modal"
                          [routerLink]="[ '/committee/dashboard']">
                          <img alt="image" class="card-img-top" src="assets/images/committee.png">
                          <h3 class="font-weight-normal mb-0 text-center">
                            คณะกรรมการบริหารกองทุนและ คณะอนุกรรมการฯ </h3>
                        </button></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-dialog" role="document" *ngIf="!admin_id" style="display:none;">
            <div class="modal-content">
              <div class="modal-header" style="background-color: white;">
                <h5 class="modal-title" id="exampleModalLabel-2">
                  เข้าสู่ระบบไม่สำเร็จ
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="ปิด">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body" style="background-color: white;" id="modal-add">
                <div class="text-center"><img src="assets/images/error.PNG"
                    style="width: 20%; height: 20%; margin-bottom: 20px;"></div>
                <div style="text-align: center;">กรุณาตรวจสอบ ชื่อผู้ใช้ หรือ รหัสผ่าน ให้ถูกต้อง</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>
<div class="container-scroller">
  <div class="col-lg-12 col-md-12 col-sm-12 grid-margin stretch-card" style="padding-left: 0px; padding-right: 0px;">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title text-center" style="margin-bottom: 40px;">เข้าสู่ website กองทุนจัดรูปที่ดินเพื่อพัฒนาพื้นที่ <span style="text-decoration: underline; cursor: pointer;" (click)="onClickHere()">click here</span></h4>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-12" style="padding-left: 0px;">
            <ul class="nav nav-tabs nav-tabs-vertical" role="tablist">
              <li class="nav-item" (click)="onClick()">
                <a class="nav-link active" id="project-tab" data-toggle="tab" href="#project" role="tab" aria-controls="project" aria-selected="true"><i class="mdi mdi-folder-multiple-outline text-danger mr-2"></i> ข้อมูลโครงการ 
                </a>
              </li>
              <li class="nav-item" (click)="onClick()">
                <a class="nav-link" id="law-tab" data-toggle="tab" href="#law" role="tab" aria-controls="law" aria-selected="false"><i class="mdi mdi-bookmark-outline text-danger mr-2"></i> กฎหมาย 
                </a>
              </li>
              <li class="nav-item" (click)="onClick()">
                <a class="nav-link" id="manual-tab" data-toggle="tab" href="#manual" role="tab" aria-controls="manual" aria-selected="false"><i class="mdi mdi-bookmark-outline text-danger mr-2"></i> คู่มือ 
                </a>
              </li>
              <li class="nav-item" (click)="onClick()">
                <a class="nav-link" id="form-tab" data-toggle="tab" href="#form" role="tab" aria-controls="form" aria-selected="false"><i class="mdi mdi-bookmark-outline text-danger mr-2"></i> แบบฟอร์ม 
                </a>
              </li>
              <li class="nav-item" (click)="onClick()">
                <a class="nav-link" id="calculate-tab" data-toggle="tab" href="#calculate" role="tab" aria-controls="calculate" aria-selected="false"><i class="mdi mdi-lightbulb-outline text-danger mr-2"></i> การคำนวณดอกเบี้ยเงินกู้เบื้องต้น 
                </a>
              </li>
              <li class="nav-item" (click)="onClick()">
                <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false"><i class="mdi mdi-account-box-outline text-danger mr-2"></i> ติดต่อกองทุน 
                </a>
              </li>
            </ul>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12" style="padding: 0px;">
            <div class="tab-content tab-content-vertical">
              <div class="tab-pane fade show active" id="project" role="tabpanel" aria-labelledby="project-tab">
                <app-data-project></app-data-project>
              </div>
              <div class="tab-pane fade" id="law" role="tabpanel" aria-labelledby="law-tab">
                  <app-law></app-law>
              </div>
              <div class="tab-pane fade" id="manual" role="tabpanel" aria-labelledby="manual-tab">
                <app-manual></app-manual>
              </div>
              <div class="tab-pane fade" id="form" role="tabpanel" aria-labelledby="form-tab">
                <app-form></app-form>
              </div>
              <div class="tab-pane fade" id="calculate" role="tabpanel" aria-labelledby="calculate-tab">
                <app-initial-interest></app-initial-interest>
              </div>
              <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                <app-contact></app-contact>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<footer class="footer" style="background-color: #FFE5D4; padding-top: 10px; padding-bottom: 10px;">
  <div class="d-sm-flex justify-content-center justify-content-sm-between">
    <span class="text-muted text-center text-sm-left d-block d-sm-inline-block"
      style="margin-top: auto; margin-bottom: 0px;">Copyright © 2021 <a href="https://www.mapedia.co.th/"
        target="_blank" style="color: #B0636E;">MAPEDIA . co . th</a>. All rights
      reserved.</span>
    <div class="text-right">
      <div class="text-right" style="margin-right: 3px;">จำนวนผู้เข้าชมเว็บไซต์</div>
      <div class="text-right">
        <span class="count-visitor" *ngFor="let i of visitor">{{i}}</span>
      </div>
    </div>
  </div>
</footer>